import React from 'react'
import DiscountApplicationRulesBxgyBuyX from './DiscountApplicationRulesBxgyBuyX'
import DiscountApplicationRulesBxgyGetY from './DiscountApplicationRulesBxgyGetY'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'
import { UiConfigDiscountType } from 'src/lib/types/discountsV2'

const DiscountApplicationRulesBxgy = () => {
  return (
    <div className='flex flex-col w-full'>
      <DiscountApplicationRulesBxgyBuyX />
      <DiscountApplicationRulesBxgyGetY type={UiConfigDiscountType.BXGY} />
      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesBxgy
